import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {},
	left: {
		boxSizing: 'border-box',
		marginRight: 15,
		width: 'calc(50% - 15px)',
	},
	lowerSection: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	right: {
		marginLeft: 15,
		width: 'calc(50% - 15px)',
	},
	upperSection: {
		margin: '30px 0',
	},
});
